import {Component, Input, Output, EventEmitter, OnInit, ElementRef, HostListener} from '@angular/core';

@Component({
    selector: 'action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {
    @Input() data: any;
    @Input() parentElementSelector: string;
    @Output('onClick') clickOutput = new EventEmitter();

    public isShow: boolean = false;
    public isDirectionTop: boolean = false;

    private parentRect;
    private element;

    constructor(private elementRef: ElementRef) {}

    ngOnInit() {
        if (this.parentElementSelector) {
            this.parentRect = document.querySelector(this.parentElementSelector).getBoundingClientRect();
            this.element = this.elementRef.nativeElement;
        }
    }

    public toggle(event): void {
        event.stopPropagation();
        if (this.parentRect) {
            this.isDirectionTop = this.isOverflowBottom();
        } else {
            this.isDirectionTop = false;
        }

        this.isShow = !this.isShow;
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

    public onClick(action, data, event): void {
        event.stopPropagation();
        this.clickOutput.emit({action, data});
    }

    private isOverflowBottom(): boolean {
        if (this.parentRect) {
            const maxHeight = this.parentRect.bottom;

            const elementReact = this.element.getBoundingClientRect();
            const dropDownHeight = this.element.querySelector('.action__dropdown-menu').getBoundingClientRect().height;
            const elementBottomPosition = elementReact.bottom + dropDownHeight;

            return elementBottomPosition > maxHeight;
        }

        return false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/documents/document-item/action-button/action-button.component.ts